var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("app-divider", { attrs: { label: "Cadastrante" } }),
      _c(
        "div",
        { staticClass: "pad5" },
        [
          _vm.cadastrante.pessoa.tipo === "PF"
            ? _c("div", [
                _c("p", [
                  _c("span", { staticClass: "label" }, [_vm._v("CPF:")]),
                  _c("span", [
                    _vm._v(
                      "  " + _vm._s(_vm.cadastrante.pessoa.pessoaFisica.cpf)
                    )
                  ])
                ]),
                _c("p", [
                  _c("span", { staticClass: "label" }, [_vm._v("Nome:")]),
                  _c("span", [
                    _vm._v(
                      "  " + _vm._s(_vm.cadastrante.pessoa.pessoaFisica.nome)
                    )
                  ])
                ]),
                _c("p", [
                  _c("span", { staticClass: "label" }, [_vm._v("Matrícula:")]),
                  _c("span", [
                    _vm._v(
                      "  " +
                        _vm._s(_vm.cadastrante.pessoa.pessoaFisica.matricula)
                    )
                  ])
                ])
              ])
            : _c("div", [
                _c("p", [
                  _c("span", { staticClass: "label" }, [_vm._v("CNPJ:")]),
                  _c("span", [
                    _vm._v(
                      "  " +
                        _vm._s(
                          _vm.filterNull(
                            _vm.cadastrante.pessoa.pessoaJuridica.cnpj
                          )
                        )
                    )
                  ])
                ]),
                _c("p", [
                  _c("span", { staticClass: "label" }, [
                    _vm._v("Razão Social:")
                  ]),
                  _c("span", [
                    _vm._v(
                      "  " +
                        _vm._s(
                          _vm.filterNull(
                            _vm.cadastrante.pessoa.pessoaJuridica.razaoSocial
                          )
                        )
                    )
                  ])
                ])
              ]),
          _c(
            "p",
            [
              _c("span", { staticClass: "label" }, [_vm._v("Telefone(s):")]),
              _vm._l(_vm.cadastrante.pessoa.telefones, function(item) {
                return _c("span", [_vm._v("  " + _vm._s(item))])
              })
            ],
            2
          ),
          _c("p", [
            _c("span", { staticClass: "label" }, [_vm._v("E-mail:")]),
            _c("span", [_vm._v("  " + _vm._s(_vm.getEmail()))])
          ]),
          _c("p", [
            _c("span", { staticClass: "label" }, [_vm._v("Solicitação:  ")]),
            _c("span", {
              domProps: { innerHTML: _vm._s(_vm.cadastrante.solicitacao) }
            })
          ]),
          _c(
            "p",
            [
              _c("span", { staticClass: "label" }, [_vm._v("Ofício:")]),
              _c("app-resumo-documentos", {
                attrs: {
                  documentos: [_vm.cadastrante.oficio],
                  codigoCadastro: "oficio",
                  idCadastro: _vm.idCadastro
                }
              })
            ],
            1
          ),
          _c("p"),
          _c("app-resumo-endereco", {
            attrs: { endereco: _vm.cadastrante.pessoa.endereco }
          }),
          _c("app-resumo-documentos", {
            attrs: {
              documentos: _vm.cadastrante.documentos,
              codigoCadastro: "cadastrante",
              idCadastro: _vm.idCadastro
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cbbba6d4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cbbba6d4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/resumo/AppResumoCadastranteAreasPatrimoniais.vue
// module id = null
// module chunks = 